/**
 * Manages Floor Description - Handles all floor description operations outside of React lifecycle
 */

/**
 * Handles the display and update of floor descriptions based on the provided floor ID.
 *
 * @param {string} floorID - The ID of the floor to match and update the corresponding description.
 */
export const HandleFloorDescription = (floorID) => {
  const floorDescriptions = document.querySelectorAll('.js-floor-desription')

  if (floorDescriptions.length) {
    floorDescriptions.forEach(floorDescription => {
      updateFloorDescription(floorDescription, floorID)
    })
  }
}

/**
 * Updates the floor description element with the title and content of a specific floor.
 *
 * Fetches floor data from a REST API and updates the provided DOM element with the
 * formatted title and content of the floor corresponding to the given floor ID.
 *
 * @param {HTMLElement} floorDescription - The DOM element where the floor description will be updated.
 * @param {number} floorID - The ID of the floor whose description is to be fetched and displayed.
 *
 * @throws {Error} Throws an error if the network response is not ok or if the floor ID is not found.
 */
const updateFloorDescription = (floorDescription, floorID) => {
  const origin = window.location.origin
  const apiUrl = '/wp-json/valve/v1/blocks/'
  let updatedFloorDescription = ''

  fetch(origin + apiUrl)
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok')
    }
    return response.json()
  })
  .then(data => {
    if (data.floors.floor_posts[floorID]) {
      // Title.
      let formattedFloorTitle = ''
      const floorTitle = data.floors.floor_posts[floorID].title
      if (floorTitle) {
        formattedFloorTitle = `<h4 class="demo__floor-description-title">${floorTitle}</h4>`
      }

      // Content.
      const floorContent = data.floors.floor_posts[floorID].content

      // Altogehter.
      const updatedFloorDescription = formattedFloorTitle + floorContent

      floorDescription.innerHTML = updatedFloorDescription

    } else {
      console.error('Floor ID not found:', floorID)
    }
  })
  .catch(error => {
    console.error('Error fetching floor data:', error)
  })
}

export default HandleFloorDescription
